export default __webpack_public_path__ + "static/media/edit.87369c17.svg";